import { Component, EventEmitter, Input, OnInit, ViewChild, Output, HostListener } from '@angular/core';

import { ResourceService } from '../../../../shared/services/resource.service';
import { ImportFileService } from '../../../services/import-file.service';
import { Configuration } from '../../../../shared/configurations/shared.config';
import { FileUploader, FileSelectDirective } from '../../fileUpload/index';
import { ImportResult } from '../../../../shared/dataModels/import';
import { Subscription } from 'rxjs';
import { ExcelService } from '../../../services/excel.service';

@Component({
    moduleId: module.id,
    selector: 'importMessageBox',
    templateUrl: 'import-message-box.component.html',
    styleUrls: ['../../../../assets/ra/sass/box-import.scss']
})

export class ImportMessageBox implements OnInit {
    public uploader: FileUploader;
    fileUploaderSubscription: Subscription;
    FileId: string;
    IsUploading: boolean = false;
    StayAlive;
    @Input() showConfirmBtn: boolean = false;
    @Input() showDismissBtn: boolean = true;
    fileUploaderMethod: Subscription;
    @Input() confirmBtnText: string;
    @Input() dismissBtnText: string;
    @Input() importType: string; // used to type name of the imported data to be displaed

    @Input() allowedFiles: string;
    @Input() isBulkUploader: boolean;  // this indicate if it's bulk upload or file reader
    @Input() excelSheetNames: string[];

    //ImportType: string;
    //@Input() message: string;
    @Input() TemplateUrl: string;
    importResult: ImportResult = new ImportResult();

    public dismissClicked: EventEmitter<any> = new EventEmitter<any>();
    url: string = Configuration.urls.webApiEndpoint + Configuration.urls.attachmentUrl;
    public hideDialog: boolean = true;
    public hideError: boolean = true;
    public ResultHideDialog: boolean = true;
    public uploadHideDialog: boolean = false;

    constructor(private resourceService: ResourceService, private importFileService: ImportFileService,
        private excelService: ExcelService) {

        this.confirmBtnText = resourceService.Localize("MessageDialog_Ok");
        this.dismissBtnText = resourceService.Localize("MessageDialog_Cancel");
        //this.message = resourceService.Localize("MessageDialog_DefaultMessage");
    }

    ngOnInit() {
        this.uploader = new FileUploader(
            {
                url: this.url,
                headers: [{ name: 'attach-type', value: 'POIImg' }],
                allowedFileType: this.allowedFiles,
                maxFileSize: "5242880",
                maxFileNameLength: "200"
            });

        if (this.isBulkUploader) {
            this.IsUploading = false;
            //File Upload Completed
            this.fileUploaderSubscription = this.uploader.fileUploadCompleted.subscribe(metadata => {

                if (metadata && metadata.response) {
                    this.IsUploading = true;
                    var response = JSON.parse(metadata.response);

                    var index = this.uploader.queue.findIndex(x => x == metadata.item);

                    if (index >= 0) {

                        this.uploader.queue[index].isSuccess = !response.IsErrorState;
                        this.uploader.queue[index].isError = response.IsErrorState;
                      
                        if (!response.IsErrorState) {
                         
                            this.FileId = response.Value.Id;
                            this.uploader.queue[index].attachmentId = response.Value.Id;
                            this.uploader.queue[index].url = response.Value.Url;
                            this.uploader.queue[index].metadata = response;
                            jQuery(".loading").css('z-index','7');
                            jQuery(".main-nav").css('z-index','2');
                            this.fileUploaderMethod = this.importFileService.ImportFromFile(this.TemplateUrl, response.Value.Id,true)
                                .subscribe(response => {
                                    jQuery(".loading").css('z-index','7');
                                    jQuery(".main-nav").css('z-index','2');
                                    this.IsUploading = false;
                                if (response) {
                                    this.importResult = response.Value;
                                    this.uploadHideDialog = true;
                                    this.ResultHideDialog = false;
                                    (this.importResult.unValidCount > 0)
                                    {
                                        this.showConfirmBtn = true;
                                    }
                                }
                            });

                        }

                    }
                }

                //this.failedToUpload = false;
                //this.messagesQueue = [];
            });
        }
    }

    show() {
        this.uploadHideDialog = false;
        this.ResultHideDialog = true;
        this.showConfirmBtn = false;
        this.hideDialog = false;
    }

    onFileAdded(event: any) {
        if (!this.isBulkUploader) {
            this.excelService.importDataToJson(event.target.files[0], this.excelSheetNames);
            this.hideDialog = true;
        }
    }

    onConfirmClick() {
        this.hideDialog = true;
    }

    onDismissClick() {
        this.uploader.vaild = true;
        this.hideDialog = true;
        this.dismissClicked.emit(true);
    }

    OnGetTemplateClick() {
        this.importFileService.GetTemplate(this.TemplateUrl).then(response => {
            console.log(response);
            if (!response) {
                this.hideError = false;
            }
            else {
                this.hideError = true;
            }
        });
    }

    ngOnDestroy() {
     
        if (this.isBulkUploader) {
            this.fileUploaderSubscription.unsubscribe();
            }
        this.uploader.vaild = true;
    }
    CanncelBulkImport() {
        if (this.FileId != null && this.IsUploading)
        this.importFileService.RemoveSesseion(this.TemplateUrl, this.FileId).subscribe(dd => { });
    }
    //when browser close end the uploading process
    @HostListener('window:beforeunload', ['$event'])
    public beforeunloadHandler($event) {
        if (this.FileId != null && this.IsUploading) {
            $event.preventDefault();
            $event.returnValue = "You Uploaded file ,is you close you will not be apple to canncel it.";
        }
       
        
      
       
    }
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/importFile/importMessageBox/import-message-box.component.ts